/**
 * #1418 — why an untargeted owner message was refused rather than guessed:
 * more than one person is mid-turn and the caller named nobody. Plain words —
 * it is shown to whoever called the local HTTP API. Its own module so the
 * HTTP handlers can use it without loading the channel.
 */
export const AMBIGUOUS_OWNER_ERROR =
  "More than one person is talking to this agent right now, so it can't tell who this is for. " +
  "Add 'conversation_id' to say which conversation, or send audience \"everyone\" to reach them all.";
